import * as styles from "./AuthorAttribution.module.scss";

import React from "react";
import { Profile } from "../common/Icons";
export interface AuthorAttributionProps {
	author?: string;
}
export const AuthorAttribution: React.FC<AuthorAttributionProps> = ({
	author,
}) => {
	return (
		<div className={styles.authorwrapper}>
			<div className={styles.icon}>
				<Profile height={"24px"} width={"24px"} />
			</div>
			<label className={styles.label}>Written by</label>
			<p className={styles.author}>{author}</p>
		</div>
	);
};

export default AuthorAttribution;
